module.exports = __webpack_public_path__ + "static/img/CAMBRIDGE-MAPLE.ff57d57.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/CAMBRIDGE-MAPLE.png
// module id = N0kD
// module chunks = 0